import InvestmentSimulationError from './InvestmentSimulationError';
class NumberOfBricksExceedsAvailable extends InvestmentSimulationError {
    numberOfBricks;
    constructor(numberOfBricks, options) {
        super('The number of bricks exceeds available', options);
        this.numberOfBricks = numberOfBricks;
    }
}
export default NumberOfBricksExceedsAvailable;
